<template>
	<div class="watch-readings-latest-modal">
		<modal-box v-if="modalBox.open" @close="onModalBoxClose" :header="$t('headers.general.reading')">
			<div slot="buttons">
				<button :class="{ 'router-link-active': isSelected('reading') }" @click="select('reading')">{{ $t('headers.general.reading') }}</button>
				<button :class="{ 'router-link-active': isSelected('position') }" @click="select('position')">{{ $t('headers.general.position') }}</button>
			</div>
			<div class="modal-reading modal-reading-generic" v-if="reading && isSelected('reading')">
				<h2 class="date-time">{{ dateTime }} ({{ timeAgo }})</h2>
				<biometric-blood-pressure v-if="isBloodPressure" v-model="reading"/>
				<biometric-calories v-else-if="isCalories" v-model="reading"/>
				<biometric-pedometer v-else-if="isPedometer" v-model="reading"/>
				<biometric-falls v-else-if="isFalls" v-model="reading"/>
				<biometric-generic v-else v-model="reading"/>
				<!-- <div class="d3-generic-container" v-if="showTopD3">
					<biometric-d3
						:type="'min'"
						:reading="reading"
						:min="reading.values.min || reading.values.diastolic_min"
						:max="reading.values.max || reading.values.diastolic_max"
						:avg="reading.values.avg || reading.values.diastolic_avg"
						:std_dev="reading.values.std_dev || reading.values.diastolic_std_dev"
						:units="units"/>
				</div>
				<div class="d3-generic-container" v-if="showBotD3">
					<biometric-d3
						:type="'max'"
						:reading="reading"
						:min="reading.values.systolic_min"
						:max="reading.values.systolic_max"
						:avg="reading.values.systolic_avg"
						:std_dev="reading.values.systolic_std_dev"
						:units="units"/>
				</div> -->
			</div>
			<div v-if="isSelected('position')">
				<div class="modal-reading modal-reading-map" v-if="position.data">
					<h2 class="date-time">{{ $moment(position.data.datetime).format('DD MMM HH:mm') }} ({{ $moment(position.data.datetime).fromNow() }})</h2>
					<h1>{{ position.data.values.latitude }} <small>lat</small><br>{{ position.data.values.longitude }} <small>lng</small></h1>
					<google-map :reading="mapReading" :mapOptions="mapOptions"/>
				</div>
			</div>
		</modal-box>
	</div>
</template>

<script>
import ApiObject from '@/classes/api/ApiObject'
import Reading from '@/classes/Reading'
import Readings from '@/utils/readings'
import BiometricBloodPressure from './ModalBoxBiometricBloodPressure'
import BiometricCalories from './ModalBoxBiometricCalories'
import BiometricPedometer from './ModalBoxBiometricPedometer'
import BiometricFalls from './ModalBoxBiometricFalls'
import BiometricGeneric from './ModalBoxBiometricGeneric'
import BiometricD3 from './ModalBoxBiometricD3'
import GoogleMap from '@/components/maps/GoogleMap'
export default {
	props: [
		'user_uid',
		'watch_id'
	],
	components: {
		BiometricBloodPressure,
		BiometricCalories,
		BiometricPedometer,
		BiometricFalls,
		BiometricGeneric,
		BiometricD3,
		GoogleMap
	},
	data () {
		return {
			reading: null,
			modalBox: {
				open: false
			},
			selected: 'reading', // reading, position,
			position: new ApiObject(),
			mapOptions: {
				zoom: 16,
				mapTypeControl: false,
				scaleControl: false,
				streetViewControl: false,
				rotateControl: false,
				fullscreenControl: false,
				zoomControl: false,
				draggable: false
			}
		}
	},
	computed: {
		dateTime () {
			return this.$moment(this.reading.datetime).format('DD MMM HH:mm')
		},
		timeAgo () {
			return this.$moment(this.reading.datetime).fromNow()
		},
		units () {
			return Readings.readingTypes.get(parseInt(this.reading.type_id)).unitHtml
		},
		isBloodPressure () {
			return this.reading.type_id === Readings.TYPE_BLOOD_PRESSURE
		},
		isCalories () {
			return this.reading.type_id === Readings.TYPE_CALORIES
		},
		isPedometer () {
			return this.reading.type_id === Readings.TYPE_PEDOMETER
		},
		isFalls () {
			return this.reading.type_id === Readings.TYPE_FALLS
		},
		showTopD3 () {
			return !this.isCalories && !this.isPedometer && !this.isFalls
		},
		showBotD3 () {
			return this.showTopD3 && this.isBloodPressure
		},
		mapReading () {
			return {
				date: this.position.data.datetime,
				position: [ this.position.data.values.latitude, this.position.data.values.longitude ]
			}
		}
	},
	methods: {
		onModalBoxClose () {
			this.modalBox.open = false
			this.reading = null
			this.position.data = null
		},
		onModalBoxOpen (reading) {
			this.reading = reading
			this.getPosition();
			this.selected = 'reading'
			this.modalBox.open = true
		},
		select (value) {
			this.selected = value
		},
		isSelected (value) {
			return this.selected == value
		},
		getPosition () {
			this.position.loading = true
			const model = {
				datetime: this.reading.datetime
			}
			this.$api.readings.getPositionNearDatetime(this, this.user_uid, this.watch_id, model)
				.then(response => {
					this.$log.info('reading', 'readings.getPositionNearDatetime OK', response)()
					this.position.data = new Reading(response.body)
				})
				.catch(error => {
					this.$log.error('reading', 'readings.getPositionNearDatetime ERROR', error)()
					this.position.error = error
				})
				.finally(() => {
					this.position.loading = false
				})
		}
	},
	created () {
		this.$parent.$on('open-modal', this.onModalBoxOpen)
	},
	beforeDestroy () {
		this.$parent.$off('open-modal', this.onModalBoxOpen)
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/readings/shared/widgets/modal/ModalBoxBiometric.vue